import UserUpdateModal from "./user-update-modal";

export default UserUpdateModal;
